export const ZOOMY = {
  navLogo: "nav-logo",
  navFleet: "nav-link-fleet",
  navStats: "nav-link-stats",
  navPartner: "nav-link-partner",
  navContact: "nav-link-contact",
  navCta: "nav-cta-contact",
  heroRentCta: "hero-cta-rent",
  heroPartnerCta: "hero-cta-partner",
  statsSection: "stats-section",
  fleetSection: "fleet-section",
  partnerSection: "partner-section",
  contactSection: "contact-section",
  leadForm: "lead-form",
  leadName: "lead-name-input",
  leadPhone: "lead-phone-input",
  leadEmail: "lead-email-input",
  leadInterest: "lead-interest-select",
  leadMessage: "lead-message-input",
  leadSubmit: "lead-submit-btn",
  leadSuccess: "lead-success-banner",
  footerPhone1: "footer-phone-1",
  footerPhone2: "footer-phone-2",
};
